import React, { useContext, useEffect, useState } from 'react'
import Appointments from '../../Components/Appointments/Appointments'
import Calendar from '../../Components/Calendar/Calendar'
import Patients from '../../Components/Patients/Patients'
import TabNav, { TabPanel } from '../../Components/TabNav/Tabnav'
import { makeStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import theme from '../../lib/theme'
import Layout from '../../Components/TopNav/Topnav'
import Ipr from '../../Components/Ipr/IprPage'
import ActiveContext from '../../Context/Context'
import axios from '../../util/axios';
import Cookies from 'js-cookie'
import CancelledBooking from '../../Components/CancelledBooking/CancelledBooking'
import NeedRescheduling from "../../Components/NeedRescheduling/need-rescheduling.component";
import Offer from "../../features/offer/components/offer";
import { CALENDAR_TAB_ORDER, TABS } from '../../util/constants/calendar-tabs.constants';
const useStyles = makeStyles(() => ({
    boxWrap: {
        padding: 25,
        backgroundColor: theme.palette.background.body,
    },
}));

export default function CalendarPage(){
    const { t } = useTranslation()
    const classes = useStyles();
    const { setClinicData, setLoading } = useContext(ActiveContext);
    const tabLabels = {
      [TABS.CALENDAR]: t("Calendar"),
      [TABS.SCAN_BOOKINGS]: t("Scan-Bookings"),
      [TABS.TREATMENT_PROCEDURES]: t("Treatment-Procedures"),
      [TABS.WALK_IN]: t("Walk-in"),
      [TABS.NEEDS_RESCHEDULING]: t("Needs Rescheduling"),
      [TABS.PATIENTS]: t("Patients"),
      [TABS.CANCELLED_BOOKING]: t("Cancelled-Booking"),
    };
    const tabs = CALENDAR_TAB_ORDER.map((key) => ({
      id: TABS[key],
      label: tabLabels[TABS[key]],
    }));
    const panels = {
      [TABS.CALENDAR]: <Calendar />,
      [TABS.SCAN_BOOKINGS]: <Appointments />,
      [TABS.TREATMENT_PROCEDURES]: <Ipr walkIn={false} />,
      [TABS.WALK_IN]: <Ipr walkIn={true} />,
      [TABS.NEEDS_RESCHEDULING]: <NeedRescheduling />,
      [TABS.PATIENTS]: <Patients />,
      [TABS.CANCELLED_BOOKING]: <CancelledBooking />,
    };

    useEffect(async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `admin/v1/clinic/profile?clinic_id=${Cookies.get("clinic_id")}`,
        );
        setClinicData(response.data);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }, []);

    return (
      <Layout>
        <Offer />
        <div className={classes.boxWrap}>
          <TabNav tabs={tabs}>
            {CALENDAR_TAB_ORDER.map((key) => (
              <TabPanel key={key}>
                {panels[TABS[key]]}
              </TabPanel>
            ))}
          </TabNav>
        </div>
      </Layout>
    );
}